import { Component, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { ActivatedRoute } from '@angular/router';
import { ExcursionServiceService } from '../service/excursion-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-supplier-confirmation',
  templateUrl: './supplier-confirmation.component.html',
  styleUrls: ['./supplier-confirmation.component.css']
})
export class SupplierConfirmationComponent implements OnInit {

  constructor(private route: ActivatedRoute,private excursionServiceService: ExcursionServiceService
    ,private toastrService: ToastrService) { }

  transferPageIndex:number = 0;
  excursionPageIndex:number = 0;
  loading:boolean = false;
  DecryptedText: string = "";
  excursionList:any = [];
  transferList:any = [];
  transferCheckAll:boolean = true;
  transferSwitchAll:boolean = true;
  moduleType:string = "";
  confirmbookingdisable:boolean = false;

  ngOnInit(): void {
    // Subscribe to the query params observable
    this.route.queryParams.subscribe(params => {
      // Access the query parameters
      const paramValue = params['q'];
      console.log('Query parameter value:', paramValue);
      //let eText = this.Encryption(paramValue);
      //console.log('Encrypted Text:' ,eText);
      let decodedData = decodeURIComponent(paramValue)
      this.DecryptedText = this.Decryption(decodedData);
      this.loadData(this.DecryptedText);
      console.log('Decrypted Text:' , this.DecryptedText);
    });
  }

  onTransferPageChange(event: any){

  }

  onExcursionPageChange(event: any){

  }

  loadData(decryptedText: string){
    let dText = decryptedText.split(';');
    let Type: string = dText[0];
    this.moduleType = Type;
    let service_id: string = "",partycode: string = "";
    let assignmentIds: string = "";
    if(Type == "Excursion"){
      service_id = dText[1];
      partycode = dText[2];
    }
    else if(Type == "Transfer"){
      assignmentIds = dText[1];
    }

    let va={
      "Type": Type,
      "service_id": service_id,
      "partycode": partycode,
      "assignmentIds": assignmentIds
    }
    
    this.excursionServiceService.getExcTransferData(va).subscribe((res: any) => {
      this.loading = true;
      if(res['result'] == 1){
        if(Type == "Excursion"){
          this.excursionList = res['data'];
          console.log(this.excursionList);

          let confrimrow:any = [];
          confrimrow = this.excursionList.filter((item:{ toursconfno: string;})=> item.toursconfno == "");
          if(confrimrow.length == 0){
            this.confirmbookingdisable = true;
          }
        }
        else if(Type == "Transfer"){
          this.transferList = res['data'];
          //console.log(this.transferList);

          let uncheckedTransferListRows: any = [];
          uncheckedTransferListRows = this.transferList.filter((item: { isChecked: boolean; })=> item.isChecked == false);

          if(uncheckedTransferListRows.length > 0){
            this.transferCheckAll = false;
          }

          let unswitchedTransferListRows: any = [];
          unswitchedTransferListRows = this.transferList.filter((item: { isSwitched: boolean; })=> item.isSwitched == false);

          if(unswitchedTransferListRows.length > 0){
            this.transferSwitchAll = false;
          }

          let confrimrow:any = [];
          confrimrow = this.transferList.filter((item:{ transferconfno: string;})=> item.transferconfno == "");
          if(confrimrow.length == 0){
            this.confirmbookingdisable = true;
          }

        }
      }
      else{
        this.toastrService.error("No data available, Please contact admin", 'Title Error!', { closeButton: true, timeOut: 3000 });
      }
      this.loading = false;
    });
  }

  Encryption(text: string): string{
    let encryptedText: string = "";
    const key = 'supConfNum@@2024';
    encryptedText = CryptoJS.AES.encrypt(text, key).toString();
    //console.log('Encrypted text:', encryptedText);
    return encryptedText;
  }

  Decryption(encryptedText: string):string{
    let decryptedText:string = "";
    const key = 'supConfNum@@2024';
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, key);
    decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
    //console.log('Decrypted text:', decryptedText);
    return decryptedText;
  }

  transferCheckAllChange(event: any){
    if(this.transferList.length > 0){
      for(let i=0; i < this.transferList.length; i++){
        this.transferList[i]["isChecked"] = event.target.checked;
      }
    }
  }

  transferSwitchAllChange(event: any){
    if(this.transferList.length > 0){
      for(let i=0; i < this.transferList.length; i++){
        this.transferList[i]["isSwitched"] = event.checked;
      }
    }
  }

  transferCheckChange(event: any, rowIndex: number){
    this.transferList[rowIndex]["isChecked"] = event.target.checked;

    let uncheckedTransferListRows: any = [];
    uncheckedTransferListRows = this.transferList.filter((item: { isChecked: boolean; })=> item.isChecked == false);

    if(uncheckedTransferListRows.length > 0){
      this.transferCheckAll = false;
    }
    else if(uncheckedTransferListRows.length == 0){
      this.transferCheckAll = true;
    }

  }

  transferSwitchChange(event: any, rowIndex: number){
    this.transferList[rowIndex]["isSwitched"] = event.checked;

    let unswitchedTransferListRows: any = [];
    unswitchedTransferListRows = this.transferList.filter((item: { isSwitched: boolean; })=> item.isSwitched == false);

    if(unswitchedTransferListRows.length > 0){
      this.transferSwitchAll = false;
    }
    else if(unswitchedTransferListRows.length == 0){
      this.transferSwitchAll = true;
    }

  }

  ConfirmBooking(){
    console.log(this.excursionList);

    let checkedTransferListRows: any = [];
    let checkedExcursionListRows: any = [];

    if(this.moduleType == "Excursion"){
      checkedExcursionListRows = this.excursionList.filter((item: { isChecked: boolean; })=> item.isChecked == true);

      let emptyConfirmationNoRows: any = [];
      emptyConfirmationNoRows = checkedExcursionListRows.filter((item: { toursconfno: string; })=> (item.toursconfno == "" || item.toursconfno == undefined  || item.toursconfno == null));

      if(emptyConfirmationNoRows.length > 0){
        this.toastrService.error("Confirmation No should not be left empty", 'Title Error!', { closeButton: true, timeOut: 3000 });
        return;
      }
    }
    else if(this.moduleType == "Transfer"){
      checkedTransferListRows = this.transferList.filter((item: { isChecked: boolean; })=> item.isChecked == true);

      let emptyConfirmationNoRows: any = [];
      emptyConfirmationNoRows = checkedTransferListRows.filter((item: { transferconfno: string; })=> (item.transferconfno == "" || item.transferconfno == undefined  || item.transferconfno == null));

      if(emptyConfirmationNoRows.length > 0){
        this.toastrService.error("Confirmation No should not be left empty", 'Title Error!', { closeButton: true, timeOut: 3000 });
        return;
      }
    }
    

    let va = {
      "moduletype": this.moduleType,
      "transferlist": checkedTransferListRows,
      "excursionlist": checkedExcursionListRows
    };

    console.log(va);

    this.excursionServiceService.updateSupplierConfirmation(va).subscribe((res: any) => {
      this.loading = true;
      if (res['result'] == 1){
        this.loadData(this.DecryptedText);
        this.toastrService.success("Supplier Confirmation Update Successfully", 'Title Success!', { closeButton: true, timeOut: 3000 });
      }
      else {
        this.toastrService.error("Supplier Confirmation Update failed, Please contact Admin", 'Title Error!', { closeButton: true, timeOut: 3000 });
      }
      this.loading = false;
    });
  }
}